export const SITE = {
    name: "ROYAL TADKA",
    tagline: "Authentic Indian flavours in the heart of Kraków.",
    phoneDisplay: "+48 739 639 527",
    phoneHref: "tel:+48739639527",
    whatsappNumber: "48739639527",
    addressLine1: "Kalwaryjska 58",
    addressLine2: "30-504 Kraków, Poland",
    hours: "Open daily 11:00 – 22:00",
    hoursShort: "11:00 – 22:00",
    mapsUrl: "https://maps.app.goo.gl/4VtzP3Lpg7V9LGyv5?g_st=ac",
    mapsEmbed:
        "https://maps.google.com/maps?q=Royal%20Tadka%2C%20Kalwaryjska%2058%2C%2030-504%20Krak%C3%B3w%2C%20Poland&t=&z=17&ie=UTF8&iwloc=&output=embed",
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
